import { render, staticRenderFns } from "./UpdateUserInfoRoleDialog.vue?vue&type=template&id=19ec65f7&scoped=true&lang=pug&"
import script from "./UpdateUserInfoRoleDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateUserInfoRoleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateUserInfoRoleDialog.vue?vue&type=style&index=0&id=19ec65f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ec65f7",
  null
  
)

export default component.exports